import React from "react";
import moment from "moment";
import { getTimeImage } from "../../../utils/utils";

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// Gift booking calendar: month grid on the left (days with times in green),
// time-slot grid on the right; stacks on small screens.
//
// `counts` is { "YYYY-MM-DD": n } from the gift calendar API, already limited
// to the gift lead time; only days with slots are clickable.
export default function GiftCalendar({
  month,
  counts,
  selectedDate,
  onSelect,
  onMonthChange,
  slots,
  selectedTime,
  onSelectTime,
  duration,
  loading,
}) {
  const start = month.clone().startOf("month");
  const cells = [];

  for (let i = 0; i < start.day(); i++) {
    cells.push(<div key={`blank-${i}`} className="vsr-day" aria-hidden="true" />);
  }
  for (let d = 1; d <= month.daysInMonth(); d++) {
    const day = start.clone().date(d);
    const key = day.format("YYYY-MM-DD");
    const available = (counts[key] || 0) > 0;
    const past = day.isBefore(moment(), "day");
    const selected = selectedDate === key;
    cells.push(
      <div key={key} className={`vsr-day ${available ? "is-available" : ""}`}>
        {available ? (
          <button
            type="button"
            className={`vsr-day-num ${selected ? "is-selected" : ""}`}
            aria-pressed={selected}
            aria-label={day.format("dddd, MMMM D")}
            disabled={loading}
            onClick={() => onSelect(key)}
          >
            {d}
          </button>
        ) : (
          <span className={`vsr-day-num ${past ? "is-past" : ""}`}>{d}</span>
        )}
      </div>
    );
  }

  const isCurrentMonth = month.isSame(moment(), "month");

  return (
    <div className="vsr-booking">
      <div className="vsr-card vsr-calendar">
        <div className="vsr-calendar-head">
          <div className="vsr-calendar-nav">
            <button
              type="button"
              className="vsr-nav-btn"
              aria-label="Previous month"
              disabled={isCurrentMonth || loading}
              onClick={() => onMonthChange(-1)}
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>
            <button type="button" className="vsr-nav-btn" aria-label="Next month" disabled={loading} onClick={() => onMonthChange(1)}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </div>
          <h2 className="vsr-calendar-month">{month.format("MMMM YYYY")}</h2>
        </div>
        <div className="vsr-calendar-grid">
          {WEEKDAYS.map((w) => (
            <div key={w} className="vsr-weekday">
              {w}
            </div>
          ))}
          {cells}
        </div>
        <div className="vsr-legend">
          <span>
            <i className="vsr-legend-available" aria-hidden="true" />
            Times available
          </span>
          <span>
            <i className="vsr-legend-selected" aria-hidden="true" />
            Selected
          </span>
        </div>
      </div>

      <div className="vsr-card vsr-slots">
        {!selectedDate && (
          <div className="vsr-slots-empty">
            <h2>Pick a date</h2>
            <p>Choose a green date to see the available times.</p>
          </div>
        )}
        {selectedDate && (
          <>
            <h2 className="vsr-slots-date">{moment(selectedDate).format("dddd, MMMM D")}</h2>
            <p className="vsr-muted vsr-slots-sub">
              {loading
                ? "Loading times…"
                : slots.length
                ? `${slots.length} ${slots.length === 1 ? "time" : "times"} available${duration ? ` · ${duration} min each` : ""}`
                : "No times left on this date. Please choose another date."}
            </p>
            <div className="vsr-slot-grid">
              {slots.map((slot) => (
                <button
                  type="button"
                  key={slot}
                  className={`vsr-slot ${selectedTime === slot ? "is-selected" : ""}`}
                  aria-pressed={selectedTime === slot}
                  onClick={() => onSelectTime(slot)}
                >
                  {slot}
                  {getTimeImage(slot) ? <img src="/localImages/moon.png" className="vsr-slot-moon" alt="" /> : null}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
